module.exports = __webpack_public_path__ + "img/owl-blue-right.95107993.png";